import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PostPreview from '../../components/Blog/posts-preview';
import HeroPost from '../../components/Blog/hero-post';
import Footer from '../../components/Blog/footer';
import Navbar from '../../components/Navbar';
import { useRouter } from 'next/router';
import { Fallback } from '../../components/Blog/fallback';
import { useTranslation } from 'react-i18next';
import { HeadSeo } from '../../components/Seo';
export var __N_SSG = true;
export default function Posts(_ref) {
  var posts = _ref.posts,
      browserConfigProps = _ref.browserConfigProps;
  var router = useRouter();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t; //console.log(posts);


  if (router.isFallback) {
    return /*#__PURE__*/_jsx(Fallback, {});
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeadSeo, {
      siteName: 'Yalendar.com',
      title: "".concat(t('landing.easySchedulingAndOnlineMeeting')),
      url: 'https://yalendar.com/',
      description: t('landing.welcomeDescription')
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative pt-6 pb-16 sm:pb-24",
      children: [/*#__PURE__*/_jsx(Navbar, {
        appURL: 'https://app.yalendar.com',
        hideNavigation: true,
        isVisible: true
      }), /*#__PURE__*/_jsxs("section", {
        className: "px-4 mx-auto mt-16 max-w-7xl sm:mt-24",
        children: [/*#__PURE__*/_jsx("div", {
          className: "px-0 xl:px-14",
          children: /*#__PURE__*/_jsx(HeroPost, {
            posts: posts
          })
        }), /*#__PURE__*/_jsx("h2", {
          className: "mb-8 text-6xl font-bold leading-tight tracking-tighter ml-11 md:text-7xl",
          children: t('blog.morePost')
        }), /*#__PURE__*/_jsx("div", {
          className: "grid justify-between grid-cols-1 row-gap-20 mb-32 md:grid-cols-2 md:col-gap-16 lg:col-gap-32 md:row-gap-32",
          children: posts. // Show only blog post not selected as Hero
          filter(function (post) {
            return !post.isHero;
          }).map(function (post, index) {
            return /*#__PURE__*/_jsx(PostPreview, {
              post: post
            }, index);
          })
        }), /*#__PURE__*/_jsx(Footer, {})]
      })]
    })]
  });
}